import { render } from "./ApprovalRequiredPage.vue?vue&type=template&id=03820e43"
import script from "./ApprovalRequiredPage.vue?vue&type=script&lang=js"
export * from "./ApprovalRequiredPage.vue?vue&type=script&lang=js"

import "./ApprovalRequiredPage.vue?vue&type=style&index=0&id=03820e43&lang=scss"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__